document.addEventListener("DOMContentLoaded", () => {

  const hamburgerDesktop = getElement("hamburger-desktop");
  const spans = getSpanElements(hamburgerDesktop);
  const hamburgerMobile = getElement("hamburger-mobile");
  const mainMobileSlider = getElement("main-mobile-nav");
  const mainMobileSliderCloseButton = getElement("close-main-mobile-nav");
  const mainMobileSliderBrandSelector = getElement("brand-selector-mobile-nav");
  const mainMobileSliderTechnologySelector = getElement("technology-selector-mobile-nav");
  const brandMobileSlider = getElement("brand-mobile-nav");
  const brandMobileSliderCloseButton = getElement("close-brand-mobile-nav");
  const brandMobileSliderBackButton = getElement("brand-mobile-nav-back");
  const technologiesMobileSlider = getElement("technologies-mobile-nav");
  const technologiesMobileSliderCloseButton = getElement("close-technologies-mobile-nav");
  const technologiesMobileSliderBackButton = getElement("technologies-mobile-nav-back");
  const desktopMenu = getElement("main-menu-desktop");
  const closeButtonDesktop = getElement("close-menu-button-desktop");

  const openMenu = () => {
    toggleClass(spans[0], "rotate-45", true);
    toggleClass(spans[0], "translate-y-1.5", true);
    toggleClass(spans[1], "opacity-0", true);
    toggleClass(spans[2], "-rotate-45", true);
    toggleClass(spans[2], "-translate-y-1.5", true);
    spans[2].style.top = "0.3rem";
    toggleClass(desktopMenu, "hidden", false);
  };

  const openMenuMobile = () => {
    toggleClass(mainMobileSlider, "-translate-x-full", false);
    toggleClass(mainMobileSlider, "translate-x-0", true);
  };

  const closeMenu = () => {
    toggleClass(spans[0], "rotate-45", false);
    toggleClass(spans[0], "translate-y-1.5", false);
    toggleClass(spans[1], "opacity-0", false);
    toggleClass(spans[2], "-rotate-45", false);
    toggleClass(spans[2], "-translate-y-1.5", false);
    spans[2].style.top = "0.5rem";
    toggleClass(desktopMenu, "hidden", true);
  };

  const closeMenuMobile = () => {
    toggleClass(mainMobileSlider, "translate-x-0", false);
    toggleClass(mainMobileSlider, "-translate-x-full", true);
  };

  const toggleMenu = (hamburger, openEventName, closeEventName) => {
    const isOpen = hamburger.classList.toggle("open");
    const eventName = isOpen ? openEventName : closeEventName;
    const event = new Event(eventName)
    dispatchCustomEvent(event);
  };

  const toggleMenuDesktop = () => {
    toggleMenu(hamburgerDesktop, "openNavDesktop", "closeNavDesktop");
  };

  const toggleMenuMobile = () => {
    toggleMenu(hamburgerMobile, "openNavMobile", "closeNavMobile");
  };


  const openBrandNavMobile = () => {
    openSlider(brandMobileSlider);
  };

  const closeBrandNavMobile = () => {
    closeSlider(brandMobileSlider);
  };

  const openTechnologyNavMobile = () => {
    console.log("✅ Opening Products Menu (menu-level-one-slider)");
    const productsMenuSlider = getElement("menu-level-one-slider");
    console.log("Products menu slider:", productsMenuSlider);
    if (!productsMenuSlider) {
        console.error("❌ Error: menu-level-one-slider not found in the DOM!");
        return;
    }
    openSlider(productsMenuSlider);
};



const closeTechnologyNavMobile = () => {
    console.log(" Closing Technologies Mega Menu");
    closeSlider(technologiesMobileSlider );
};

  const closeAllMobileMenus = () => {
    closeTechnologyNavMobile();
    closeBrandNavMobile();
    closeMenuMobile();
  };

  addEventListener(hamburgerDesktop, "click", toggleMenuDesktop);
  addEventListener(hamburgerMobile, "click", toggleMenuMobile);
  addEventListener(mainMobileSliderCloseButton, "click", closeMenuMobile);
  addEventListener(mainMobileSliderBrandSelector, "click", openBrandNavMobile);
  addEventListener(mainMobileSliderTechnologySelector, "click", openTechnologyNavMobile);
  addEventListener(brandMobileSliderBackButton, "click", closeBrandNavMobile);
  addEventListener(technologiesMobileSliderBackButton, "click", closeTechnologyNavMobile);
  addEventListener(brandMobileSliderCloseButton, "click", closeAllMobileMenus);
  addEventListener(technologiesMobileSliderCloseButton, "click", closeAllMobileMenus);

  addEventListener(closeButtonDesktop, "click", toggleMenuDesktop);

  addEventListener(document, "openNavDesktop", openMenu);
  addEventListener(document, "closeNavDesktop", closeMenu);
  addEventListener(document, "openNavMobile", openMenuMobile);
  addEventListener(document, "closeNavMobile", closeMenuMobile);
});